import { Dialog, Box } from "@mui/material";

const FullscreenDialog = ({ open, onClose, children }) => (
  <Dialog fullScreen open={open} onClose={onClose}>
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  </Dialog>
);

export default FullscreenDialog;
